import AvatarGroupModal from "./AvatarGroupModal";

export default AvatarGroupModal;